/* ON-API-PRETE */
/* on-app.js — refonte DA (05/10/2026), lot L1 « enveloppe ».
   API window.ON consommée par les gabarits (rayons, fiche, accueil) — tout script de gabarit qui l'utilise attend DOMContentLoaded :
     ON.prix(n) · ON.normaliser(s) · ON.slug(s) · ON.groupe(id|url|slug) · ON.img(url, w) · ON.srcset(url, largeurs)
     ON.carte(g, {coloris, eager, sizes}) → chaîne HTML (balisage de la carte de la référence : a.card …)
     ON.cartes(racine) (pastilles, flèches, cœurs ; idempotent) · ON.rails(racine) (barre de progression, flèches ; idempotent)
     ON.panier.{rafraichir, ajouter(variantId, qte, {ouvrir}), changer(cle, qte), ouvrir(decl), fermer, importer, etat}
       → événement « on:panier » (detail = /cart.js) sur document
     ON.panneau.{ouvrir(id, declencheur, {classe, voile, focus}), fermer(), ouvert()} · ON.toast(texte) ·
     ON.favoris.{basculer(id), liste(), contient(id)} → événement « on:favoris »
   Comportement porté de app.js (site de référence) SANS ses défauts (PORTAGE.md § 4) : verrou du défilement sur <html> ET <body>,
   dialogues avec focus piégé puis rendu, Échap, aria-expanded, seuil d'en-tête par IntersectionObserver, barre de progression des
   étagères, total réel du panier, aucun compte à rebours, aucun traceur. */
(function () {
  'use strict';
  var ON = window.ON = window.ON || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var lire = function (k, d) { try { var v = JSON.parse(localStorage.getItem(k)); return v == null ? d : v; } catch (e) { return d; } };
  var ecrire = function (k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} };
  var emettre = function (nom, detail) { try { document.dispatchEvent(new CustomEvent(nom, { detail: detail })); } catch (e) {} };
  ON.esc = esc;

  /* ---------- 1. Utilitaires ---------- */
  var FMT = null;
  try { FMT = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }); } catch (e) {}
  // Séparateur de milliers (défaut 25 de la référence) : « 1 234,50 € ».
  ON.prix = function (n) {
    n = Number(n) || 0;
    if (FMT) return FMT.format(n);
    return n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' €';
  };
  ON.normaliser = function (s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); };
  // Même règle que tools/chiffres.mjs : minuscules, sans accents, tout le reste → « - ».
  ON.slug = function (s) {
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  };
  var INDEX = null;
  function indexer() {
    INDEX = {};
    (window.CATALOGUE || []).forEach(function (g) {
      INDEX['g' + g.id] = g;
      if (g.url) INDEX['u' + g.url] = g;
      if (g.slug) INDEX['s' + g.slug] = g;
      (g.coloris || []).forEach(function (c) {
        if (!INDEX['g' + c.id]) INDEX['g' + c.id] = g;
        if (c.url) { INDEX['u' + c.url] = g; INDEX['s' + c.url.replace(/^.*\/products\//, '')] = g; }
      });
    });
  }
  // Groupe de coloris par identifiant de groupe ou de coloris (= produit Shopify), adresse /products/… ou handle.
  ON.groupe = function (id) {
    if (id == null || id === '') return null;
    if (!INDEX || !Object.keys(INDEX).length) indexer();
    var s = String(id);
    return INDEX['g' + s] || INDEX['u' + s.replace(/[?#].*$/, '').replace(/^https?:\/\/[^/]+/, '').replace(/\/$/, '')] || INDEX['s' + s] || null;
  };
  // Coloris d'un groupe : par index, identifiant (produit) ou objet ; défaut = le premier.
  ON.coloris = function (g, c) {
    var l = (g && g.coloris) || [];
    if (c && typeof c === 'object') return c;
    if (typeof c === 'number' && c >= 0 && c < l.length && !l.some(function (x) { return x.id === c; })) return l[c];
    if (c != null) { for (var i = 0; i < l.length; i++) if (String(l[i].id) === String(c) || l[i].url === c) return l[i]; }
    return l[0] || null;
  };
  // Photos du CDN Shopify : largeur demandée par le paramètre width= (jamais l'image source de 1 600 px dans une vignette).
  ON.img = function (url, w) {
    if (!url) return '';
    url = String(url);
    if (!w || !/cdn\.shopify\.com\/|\/cdn\/shop\//.test(url)) return url;
    url = url.replace(/([?&])width=\d+(&|$)/, function (m, a, b) { return b ? a : ''; }).replace(/[?&]$/, '');
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  };
  ON.LARGEURS = [360, 540, 720, 900, 1080];
  ON.srcset = function (url, largeurs) {
    if (!url || !/cdn\.shopify\.com\/|\/cdn\/shop\//.test(url)) return '';
    return (largeurs || ON.LARGEURS).map(function (w) { return ON.img(url, w) + ' ' + w + 'w'; }).join(', ');
  };

  /* ---------- 2. Favoris (localStorage, par produit = coloris) ---------- */
  var FAV = 'on_favoris';
  ON.favoris = {
    liste: function () { var l = lire(FAV, []); return Array.isArray(l) ? l.map(Number).filter(Boolean) : []; },
    contient: function (id) { return ON.favoris.liste().indexOf(Number(id)) !== -1; },
    basculer: function (id) {
      id = Number(id); if (!id) return false;
      var l = ON.favoris.liste(), i = l.indexOf(id), ajoute = i === -1;
      if (ajoute) l.unshift(id); else l.splice(i, 1);
      ecrire(FAV, l);
      synchroFavoris();
      emettre('on:favoris', { id: id, actif: ajoute, liste: l });
      return ajoute;
    },
  };
  function synchroFavoris(racine) {
    var l = ON.favoris.liste();
    $$('[data-fav]', racine).forEach(function (b) {
      var on = l.indexOf(Number(b.getAttribute('data-fav'))) !== -1;
      b.setAttribute('aria-pressed', String(on));
      b.setAttribute('aria-label', on ? 'Retirer des favoris' : 'Ajouter aux favoris');
    });
  }

  /* ---------- 3. Carte produit (balisage de la référence) ---------- */
  var COEUR = '<svg viewBox="0 0 24 24" width="21" height="21" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" aria-hidden="true"><path d="M12 20.3C12 20.3 4.4 15.8 4.4 10.7A4.2 4.2 0 0 1 12 8.2a4.2 4.2 0 0 1 7.6 2.5c0 5.1-7.6 9.6-7.6 9.6Z"/></svg>';
  var SIZES_DEFAUT = '(max-width: 759px) 50vw, (min-width: 1600px) 520px, 33vw';
  var ON_PALIERS = [50, 30, 20];   // paliers affichés (tools/prix-paliers.mjs)
  // Prix d'un coloris : payé (promo) et barré (prix normal) ; remise arrondie à l'INFÉRIEUR, affichée à partir de 5 %.
  ON.prixDe = function (c) {
    var prix = Number(c && c.prix) || 0, paye = Number(c && c.promo) || 0;
    if (!(paye > 0) || paye > prix) paye = prix || paye;
    var barre = paye < prix ? prix : 0;
    var pct = barre ? Math.floor((1 - paye / prix) * 100 + 1e-9) : 0;
    // Paliers de la grille de prix (06/10/2026) : on affiche le palier ATTEINT (−50, −30 ou −20 %), jamais plus que
    // la remise réelle (L121-2) ; les prix de vente sont arrondis au X9,90 INFÉRIEUR, donc la remise réelle est ≥ son palier.
    for (var i = 0; i < ON_PALIERS.length; i++) { if (pct >= ON_PALIERS[i]) { pct = ON_PALIERS[i]; break; } }
    return { paye: paye, barre: barre, remise: pct >= 5 ? pct : 0 };
  };
  // Rareté sur le stock réel : « Épuisé » sans taille ; « Bientôt en rupture » s'il en reste 1 ou 2 sur au moins 4.
  ON.rarete = function (c) {
    var t = (c && c.tailles) || [];
    if (!t.length) return 'Épuisé';
    if (t.length <= 2 && Number(c.nt) >= 4) return 'Bientôt en rupture';
    return '';
  };
  ON.carte = function (g, o) {
    o = o || {};
    if (g == null) return '';
    if (typeof g !== 'object') g = ON.groupe(g);
    if (!g) return '';
    var cols = (g.coloris && g.coloris.length) ? g.coloris
      : [{ id: g.id, url: g.url, couleur: '', prix: g.prix, promo: g.promo, images: g.image ? [g.image] : [], tailles: ['?'], nt: 0 }];
    var c = ON.coloris(g, o.coloris) || cols[0];
    var ordre = [c].concat(cols.filter(function (x) { return x !== c; }));
    var p = ON.prixDe(c), rare = ON.rarete(c);
    var imgs = (c.images && c.images.length) ? c.images : (g.image ? [g.image] : []);
    var sizes = o.sizes || SIZES_DEFAUT, eager = !!o.eager;
    var vue = function (u, cls, alt) {
      return '<img' + (cls ? ' class="' + cls + '"' : '') + ' src="' + esc(ON.img(u, 720)) + '" srcset="' + esc(ON.srcset(u)) + '" sizes="' + esc(sizes) +
        '" alt="' + esc(alt) + '"' + (cls ? ' aria-hidden="true"' : '') +
        (eager && !cls ? ' loading="eager" fetchpriority="high"' : ' loading="lazy"') + ' decoding="async" width="900" height="900">';
    };
    var fav = ON.favoris.contient(c.id);
    var h = '<a class="card" href="' + esc(c.url || g.url) + '" data-id="' + esc(g.id) + '" data-coloris-id="' + esc(c.id) +
      '" data-cat="' + esc(ON.slug(g.sous_cat)) + '" data-categorie="' + esc(ON.slug(g.categorie)) + '" data-gender="' + esc(g.rayon || '') +
      '" data-prix="' + esc(p.paye) + '" data-tailles="' + esc((c.tailles || []).join(' ')) + '" data-coloris="' +
      esc(ordre.map(function (x) { return ON.slug(x.couleur); }).join(' ')) + '">' +
      '<div class="card__media">' +
        (p.remise ? '<span class="solde">−' + p.remise + '%</span>' : '') +
        '<span class="card__fav" role="button" tabindex="0" data-fav="' + esc(c.id) + '" aria-pressed="' + fav + '" aria-label="' +
          (fav ? 'Retirer des favoris' : 'Ajouter aux favoris') + '">' + COEUR + '</span>' +
        (imgs[0] ? vue(imgs[0], '', g.nom) : '') + (imgs[1] ? vue(imgs[1], 'card__img2', '') : '') +
      '</div>' +
      '<div class="card__body">' +
        (rare ? '<span class="rupture">' + rare + '</span>' : '') +
        '<div class="swatches"><span class="sw-nav sw-nav--prev" role="button" tabindex="-1" aria-label="Coloris précédents" hidden>←</span>' +
          '<div class="swatches__piste">' + ordre.map(function (x) {
            var u = (x.images && x.images[0]) || g.image || '';
            return '<i class="sw" data-coloris="' + esc(ON.slug(x.couleur)) + '" data-url="' + esc(x.url || '') + '">' +
              (u ? '<img src="' + esc(ON.img(u, 92)) + '" srcset="' + esc(ON.srcset(u, [60, 92, 140])) + '" sizes="46px" alt="' + esc(x.couleur || '') +
                '" title="' + esc(x.couleur || '') + '" loading="lazy" decoding="async" width="48" height="48">' : '') + '</i>';
          }).join('') + '</div>' +
          '<span class="sw-nav sw-nav--next" role="button" tabindex="-1" aria-label="Coloris suivants" hidden>→</span></div>' +
        '<div class="card__name"><span>' + esc(g.nom) + '</span></div>' +
        '<div class="card__desc">' + esc([g.rayon, g.sous_cat].filter(Boolean).join(' – ')) + '</div>' +
        '<div class="price">' + (p.barre ? '<s>' + ON.prix(p.barre) + '</s>' : '') + '<b>' + ON.prix(p.paye) + '</b></div>' +
      '</div></a>';
    return h;
  };

  // Pastilles de coloris : flèches seulement si la piste déborde (mesuré au rendu, comme la référence).
  function ajusterPastilles(bloc) {
    var piste = $('.swatches__piste', bloc);
    if (!piste || !piste.clientWidth) return;
    var deborde = piste.scrollWidth - piste.clientWidth > 1;
    var prev = $('.sw-nav--prev', bloc), next = $('.sw-nav--next', bloc);
    [prev, next].forEach(function (f) { if (f) f.hidden = !deborde; });
    if (!deborde) return;
    var reste = piste.scrollWidth - piste.clientWidth - piste.scrollLeft;
    if (prev) prev.setAttribute('aria-disabled', String(piste.scrollLeft <= 1));
    if (next) next.setAttribute('aria-disabled', String(reste <= 1));
  }
  var RO = window.ResizeObserver ? new ResizeObserver(function (l) {
    l.forEach(function (e) { var b = e.target.closest('.swatches'); if (b) ajusterPastilles(b); });
  }) : null;
  ON.cartes = function (racine) {
    $$('.swatches', racine).forEach(function (bloc) {
      if (bloc.dataset.onPret) return;
      bloc.dataset.onPret = '1';
      var piste = $('.swatches__piste', bloc);
      if (!piste) return;
      piste.addEventListener('scroll', function () { ajusterPastilles(bloc); }, { passive: true });
      if (RO) RO.observe(piste);
      ajusterPastilles(bloc);
    });
    synchroFavoris(racine);
  };

  /* ---------- 4. Rails (accueil, fiche) : barre de progression qui fonctionne aussi sur les étagères .shelf (défaut 14) ---------- */
  ON.rails = function (racine) {
    racine = racine || document;
    var wraps = $$('[data-rail]', racine);
    if (racine.matches && racine.matches('[data-rail]')) wraps.unshift(racine);
    wraps.forEach(function (wrap) {
      if (wrap.dataset.onRail) return;
      var rail = $('.rail, .shelf', wrap);
      if (!rail) return;
      wrap.dataset.onRail = '1';
      var bar = $('.rail-bar i', wrap), prev = $('[data-rail-prev]', wrap), next = $('[data-rail-next]', wrap);
      function sync() {
        var max = rail.scrollWidth - rail.clientWidth;
        if (bar) {
          var ratio = rail.scrollWidth ? rail.clientWidth / rail.scrollWidth : 1;
          var l = Math.max(Math.min(ratio, 1) * 100, 8), pos = max > 0 ? rail.scrollLeft / max : 0;
          bar.style.width = l + '%';
          bar.style.left = pos * (100 - l) + '%';
        }
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= max - 2;
      }
      function pousser(sens) { rail.scrollBy({ left: sens * Math.max(rail.clientWidth - 60, 120), behavior: 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { pousser(-1); });
      if (next) next.addEventListener('click', function () { pousser(1); });
      rail.addEventListener('scroll', sync, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(sync).observe(rail); else window.addEventListener('resize', sync);
      sync();
    });
    ON.cartes(racine);
  };

  /* ---------- 5. Toast : posé AU-DESSUS des barres fixes du bas (barre d'onglets, barre d'achat), jamais sur elles ---------- */
  var toastMinuteur;
  ON.toast = function (texte) {
    var t = $('#toast');
    if (!t) return;
    // Les barres s'EMPILENT (fiche mobile : barre d'achat posée sur la barre d'onglets) : on remonte la pile depuis le bas de l'écran.
    // Ne regarder que la barre qui touche le bas posait le toast SUR « Ajouter au panier » (mesuré le 05/10 : défaut 9 de la référence).
    var barres = $$('.hdr-act, .buybar, [data-barre-basse]').map(function (b) {
      var cs = getComputedStyle(b);
      if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') return null;
      var r = b.getBoundingClientRect();
      return r.height && r.top < window.innerHeight ? r : null;
    }).filter(Boolean);
    var bas = window.innerHeight, monte = true;
    while (monte) {
      monte = false;
      barres.forEach(function (r) { if (r.top < bas && r.bottom >= bas - 4) { bas = r.top; monte = true; } });
    }
    t.style.bottom = Math.max(26, window.innerHeight - bas + 12) + 'px';
    t.textContent = texte;
    t.classList.add('show');
    clearTimeout(toastMinuteur);
    toastMinuteur = setTimeout(function () { t.classList.remove('show'); }, 2400);
  };

  /* ---------- 6. Panneaux : dialogue modal, verrou <html> + <body>, focus piégé puis rendu, Échap (défauts 11 et 12) ---------- */
  var courant = null;
  var FOCUSABLES = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]), summary';
  function focusables(el) {
    return $$(FOCUSABLES, el).filter(function (x) {
      if (x.closest('[inert]') || x.closest('[hidden]')) return false;
      var r = x.getBoundingClientRect();
      return r.width > 0 && r.height > 0 && getComputedStyle(x).visibility !== 'hidden';
    });
  }
  function verrou(on) {
    document.documentElement.classList.toggle('on-verrou', on);
    document.body.classList.toggle('on-verrou', on);
  }
  function expanded(id, val, decl) {
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', String(val)); });
    if (decl && decl.setAttribute) decl.setAttribute('aria-expanded', String(val));
  }
  ON.panneau = {
    ouvert: function () { return courant ? courant.el.id : null; },
    ouvrir: function (id, decl, o) {
      var el = typeof id === 'string' ? document.getElementById(id) : id;
      if (!el) return;
      o = o || {};
      if (courant && courant.el !== el) ON.panneau.fermer({ rendreFocus: false });
      if (courant && courant.el === el) return;
      decl = decl || document.activeElement;
      var voile = o.voile !== undefined ? o.voile : el.id !== 'rech';
      courant = { el: el, decl: decl, classe: o.classe || 'open', voile: voile, scroll: window.scrollY };
      el.removeAttribute('inert');
      el.classList.add(courant.classe);
      // aria-hidden / inert : seulement sur les panneaux qui le déclarent (data-inert). Le volet de filtres du rayon redevient une
      // colonne visible au-delà de 900 px : il ne doit jamais rester masqué aux lecteurs d'écran.
      if (el.hasAttribute('data-inert')) el.setAttribute('aria-hidden', 'false');
      if (voile) { var s = $('#scrim'); if (s) s.classList.add('open'); }
      verrou(true);
      expanded(el.id, true, decl);
      var cible = o.focus ? (typeof o.focus === 'string' ? $(o.focus, el) : o.focus) : null;
      // Le panneau devient visible au fil de sa transition (visibility) : le focus est posé, puis reposé à la fin si besoin.
      var poserFocus = function () {
        if (!courant || courant.el !== el || el.contains(document.activeElement)) return;
        var f = cible || $('[autofocus]', el) || focusables(el)[0] || el;
        if (f === el && !el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
        try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); }
      };
      requestAnimationFrame(poserFocus);
      setTimeout(poserFocus, 280);
      emettre('on:panneau', { id: el.id, ouvert: true });
    },
    fermer: function (o) {
      if (!courant) return;
      o = o || {};
      var c = courant; courant = null;
      c.el.classList.remove(c.classe);
      if (c.el.hasAttribute('data-inert')) { c.el.setAttribute('aria-hidden', 'true'); c.el.setAttribute('inert', ''); }
      var s = $('#scrim'); if (s) s.classList.remove('open');
      verrou(false);
      expanded(c.el.id, false, c.decl);
      if (Math.abs(window.scrollY - c.scroll) > 2) window.scrollTo(0, c.scroll);
      if (o.rendreFocus !== false && c.decl && c.decl.focus && document.contains(c.decl)) {
        try { c.decl.focus({ preventScroll: true }); } catch (e) { c.decl.focus(); }
      }
      emettre('on:panneau', { id: c.el.id, ouvert: false });
    },
  };
  document.addEventListener('keydown', function (e) {
    if (!courant) return;
    if (e.key === 'Escape') { e.preventDefault(); ON.panneau.fermer(); return; }
    if (e.key !== 'Tab') return;
    var l = focusables(courant.el);
    if (!l.length) { e.preventDefault(); return; }
    var i = l.indexOf(document.activeElement);
    if (e.shiftKey && (i <= 0)) { e.preventDefault(); l[l.length - 1].focus(); }
    else if (!e.shiftKey && (i === -1 || i === l.length - 1)) { e.preventDefault(); l[0].focus(); }
  });
  // Défilement « par-dessus » un panneau (molette, toucher) : la page ne bouge pas — le verrou CSS suffit sauf sur les vieux iOS.
  window.addEventListener('scroll', function () {
    if (courant && Math.abs(window.scrollY - courant.scroll) > 1) window.scrollTo(0, courant.scroll);
  }, { passive: true });

  /* ---------- 7. Panier sur /cart.js (tiroir de la référence, total réel) ---------- */
  var PANIER = null, occupe = false;
  var json = function (r) {
    return r.text().then(function (t) {
      var j = null; try { j = JSON.parse(t); } catch (e) {}
      if (!r.ok || !j) { var e = new Error((j && (j.description || j.message)) || ('HTTP ' + r.status)); e.statut = r.status; throw e; }
      return j;
    });
  };
  // Shopify répond 429 quand les requêtes se suivent de trop près : on réessaie (deux fois, 1,2 s puis 2,4 s) au lieu d'échouer.
  var appeler = function (u, init, essai) {
    essai = essai || 0;
    return fetch(u, init).then(function (r) {
      if (r.status === 429 && essai < 2) return new Promise(function (ok) { setTimeout(ok, 1200 * (essai + 1)); }).then(function () { return appeler(u, init, essai + 1); });
      return json(r);
    });
  };
  var poster = function (u, corps) {
    return appeler(u, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(corps) });
  };
  function peindreCompteurs(n) {
    $$('.cart-count').forEach(function (el) { el.textContent = n; el.hidden = !n; });
    $$('#cartBtn, #mnavCart').forEach(function (b) { b.setAttribute('aria-label', n ? 'Panier, ' + n + (n > 1 ? ' articles' : ' article') : (b.id === 'cartBtn' ? 'Ouvrir le panier' : 'Panier')); });
  }
  function infosLigne(it) {
    // Les identifiants du catalogue sont ceux du WP : la ligne est rapprochée par son adresse /products/<handle>.
    var u = String(it.url || '').split('?')[0], g = ON.groupe(u) || ON.groupe(it.product_id), c = null;
    if (g) (g.coloris || []).some(function (x) { if (x.url === u) { c = x; return true; } return false; });
    var nom = g ? g.nom : String(it.product_title || '').split(' · ')[0];
    var couleur = c && c.couleur ? c.couleur : (String(it.product_title || '').split(' · ')[1] || '');
    var opt = (it.options_with_values || []).filter(function (x) { return x && x.value && x.value !== 'Default Title'; })[0];
    var taille = opt ? (/unique/i.test(opt.value) ? opt.value : (opt.name || 'Taille') + ' ' + opt.value) : '';
    var unitaire = (it.final_price || it.price || 0) / 100;
    var normal = c && Number(c.prix) > unitaire + 0.001 ? Number(c.prix) : ((it.original_price || 0) / 100 > unitaire + 0.001 ? it.original_price / 100 : 0);
    return { nom: nom, couleur: couleur, taille: taille, barre: normal ? normal * it.quantity : 0, paye: (it.final_line_price || 0) / 100 };
  }
  function ligneHTML(it) {
    var x = infosLigne(it), img = it.image || (it.featured_image && it.featured_image.url) || '';
    return '<div class="line" data-key="' + esc(it.key) + '" data-variant="' + esc(it.variant_id) + '">' +
      '<a class="line-img" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(ON.img(img, 180)) + '" srcset="' + esc(ON.srcset(img, [90, 180, 270])) +
        '" sizes="84px" alt="' + esc(x.nom) + '" loading="lazy" decoding="async" width="84" height="84">' : '') + '</a>' +
      '<div><div class="line-name">' + esc(x.nom) + '</div>' +
      '<div class="line-var">' + [x.couleur, x.taille].filter(Boolean).map(esc).join(' · ') + '</div>' +
      '<div class="qty"><button type="button" data-q="-1" aria-label="Retirer un ' + esc(x.nom) + '">−</button><span aria-live="polite">' + it.quantity +
        '</span><button type="button" data-q="1" aria-label="Ajouter un ' + esc(x.nom) + '">+</button></div>' +
      '<button type="button" class="line-rm">Supprimer</button></div>' +
      '<div class="line-price">' + (x.barre ? '<s>' + ON.prix(x.barre) + '</s>' : '') + ON.prix(x.paye) + '</div></div>';
  }
  function peindre(cart) {
    PANIER = cart;
    var n = cart ? cart.item_count : 0;
    peindreCompteurs(n);
    var body = $('#drawerBody'), foot = $('#drawerFoot');
    if (!body) return;
    if (!n) {
      body.innerHTML = '<div class="empty"><p>Votre panier est vide.</p><a class="btn btn--block" href="/collections/all">Découvrir la collection</a></div>';
      if (foot) foot.innerHTML = '';
      return;
    }
    body.innerHTML = cart.items.map(ligneHTML).join('');
    var remise = (cart.total_discount || 0) / 100;
    var pay = $('.pied .paiements');
    if (foot) foot.innerHTML =
      '<div class="totals dft-totals">' +
        (remise > 0 ? '<div class="save"><span>Remise</span><span>−' + ON.prix(remise) + '</span></div>' : '') +
        '<div><span>Livraison</span><span>Offerte</span></div>' +
      '</div>' +
      '<div class="dft-total"><span>Total</span><b>' + ON.prix(cart.total_price / 100) + '</b></div>' +
      '<a class="btn btn--block" id="coBtn" href="/checkout">Commander</a>' +
      '<button type="button" class="btn btn--outline btn--block" data-close>Continuer mes achats</button>' +
      (pay ? '<div class="dft-pay pay" aria-label="Moyens de paiement acceptés">' + pay.innerHTML + '</div>' : '');
  }
  // Le focus survit au rendu (défaut 27) : rendu à l'élément équivalent de la même ligne, sinon au titre du tiroir.
  function memoFocus() {
    var a = document.activeElement, l = a && a.closest ? a.closest('.line') : null;
    if (!l) return null;
    return { v: l.getAttribute('data-variant'), q: a.getAttribute('data-q'), rm: a.classList.contains('line-rm') };
  }
  function rendreFocus(m) {
    if (!m) return;
    var l = $('#drawerBody .line[data-variant="' + m.v + '"]'), cible = null;
    if (l) cible = m.rm ? $('.line-rm', l) : (m.q ? $('[data-q="' + m.q + '"]', l) : null);
    cible = cible || $('#drawer .drawer-hd [data-close]') || $('#drawer');
    try { cible.focus({ preventScroll: true }); } catch (e) {}
  }
  ON.panier = {
    etat: function () { return PANIER; },
    rafraichir: function () {
      return appeler('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (c) {
        var m = memoFocus(); peindre(c); rendreFocus(m); emettre('on:panier', c); return c;
      });
    },
    ajouter: function (variantId, qte, o) {
      o = o || {};
      var decl = document.activeElement;
      return poster('/cart/add.js', { items: [{ id: Number(variantId), quantity: Math.max(1, parseInt(qte, 10) || 1) }] })
        .then(function () { return ON.panier.rafraichir(); })
        .then(function (c) { if (o.ouvrir !== false) ON.panier.ouvrir(decl); return c; })
        .catch(function (e) { ON.toast(e.statut === 422 ? (e.message || 'Cette taille n’est plus disponible.') : 'Le panier est momentanément indisponible : réessayez dans un instant.'); throw e; });
    },
    changer: function (cle, qte) {
      if (occupe) return Promise.resolve(PANIER);
      occupe = true;
      var d = $('#drawer'); if (d) d.setAttribute('aria-busy', 'true');
      var m = memoFocus();
      return poster('/cart/change.js', { id: String(cle), quantity: Math.max(0, parseInt(qte, 10) || 0) })
        .then(function (c) { peindre(c); rendreFocus(m); emettre('on:panier', c); return c; })
        .catch(function () { ON.toast('Connexion interrompue : réessayez dans un instant.'); return ON.panier.rafraichir(); })
        .then(function (c) { occupe = false; if (d) d.removeAttribute('aria-busy'); return c; });
    },
    ouvrir: function (decl) { ON.panneau.ouvrir('drawer', decl || document.activeElement, { focus: '.drawer-hd [data-close]' }); },
    fermer: function () { if (ON.panneau.ouvert() === 'drawer') ON.panneau.fermer(); },
    // Panier hérité du WordPress (localStorage.on_panier) : importé UNE fois si le panier Shopify est vide, puis effacé.
    importer: function () {
      var items = lire('on_panier', []);
      if (!Array.isArray(items) || !items.length) { if (items && !Array.isArray(items)) ecrire('on_panier', null); return Promise.resolve(0); }
      return appeler('/cart.js', { credentials: 'same-origin' }).then(function (c) {
        if (c.item_count > 0 || typeof window.onPont !== 'function') { ecrire('on_panier', null); return 0; }
        return window.onPont(items).then(function () { ecrire('on_panier', null); return ON.panier.rafraichir(); })
          .then(function (c2) { return c2 ? c2.item_count : 0; });
      }).catch(function () { return 0; });
    },
  };

  /* ---------- 8. Délégation des clics ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b;
    if ((b = t.closest('.card__fav'))) { e.preventDefault(); e.stopPropagation(); ON.favoris.basculer(b.getAttribute('data-fav')); return; }
    if ((b = t.closest('.sw-nav'))) {
      e.preventDefault(); e.stopPropagation();
      if (b.getAttribute('aria-disabled') === 'true') return;
      var piste = $('.swatches__piste', b.parentNode);
      if (piste) piste.scrollBy({ left: (b.classList.contains('sw-nav--prev') ? -1 : 1) * Math.max(110, Math.round(piste.clientWidth * 0.8)), behavior: 'smooth' });
      return;
    }
    if ((b = t.closest('.sw[data-url]')) && b.closest('a.card')) {
      var u = b.getAttribute('data-url');
      if (!u) return;
      e.preventDefault(); e.stopPropagation();
      if (e.metaKey || e.ctrlKey || e.shiftKey) window.open(u, '_blank'); else location.href = u;
      return;
    }
    if (t.closest('#cartBtn')) { e.preventDefault(); ON.panier.ouvrir(t.closest('#cartBtn')); return; }
    if (t.closest('#burger')) { e.preventDefault(); ON.panneau.ouvrir('mnav', t.closest('#burger')); return; }
    if (t.closest('#searchBtn')) { e.preventDefault(); ouvrirRecherche(t.closest('#searchBtn')); return; }
    if (t.closest('#mnavCart')) { e.preventDefault(); var dc = $('#burger'); ON.panneau.fermer({ rendreFocus: false }); ON.panier.ouvrir(dc); return; }
    if (t.closest('#mnavSearch')) { e.preventDefault(); var ds = $('#burger'); ON.panneau.fermer({ rendreFocus: false }); ouvrirRecherche(ds); return; }
    if (t.closest('#scrim') || t.closest('[data-close]') || t.closest('[data-rech-close]')) { ON.panneau.fermer(); return; }
    if (t.id === 'rech' && courant && courant.el.id === 'rech') { ON.panneau.fermer(); return; }
    var q = t.closest('#drawer [data-q], #cartPage [data-q]');
    if (q) {
      var l = q.closest('.line'), n = Number((($('.qty span', l) || {}).textContent) || 1) + Number(q.getAttribute('data-q'));
      ON.panier.changer(l.getAttribute('data-key'), n); return;
    }
    if ((b = t.closest('#drawer .line-rm, #cartPage .line-rm'))) { ON.panier.changer(b.closest('.line').getAttribute('data-key'), 0); return; }
  });
  // Cœur au clavier (Entrée, Espace) : il est dans le lien de la carte, la touche ne doit pas ouvrir la fiche.
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target && e.target.classList && e.target.classList.contains('card__fav')) {
      e.preventDefault(); e.stopPropagation(); ON.favoris.basculer(e.target.getAttribute('data-fav'));
    }
  }, true);

  /* ---------- 9. Recherche instantanée sur CATALOGUE (ET sur tous les mots, sans accents ni casse ; Entrée → /search?q=) ---------- */
  var IDX_RECH = null;
  function indexRecherche() {
    if (IDX_RECH) return IDX_RECH;
    IDX_RECH = (window.CATALOGUE || []).map(function (g) {
      return { g: g, foin: ON.normaliser([g.nom, g.rayon, g.categorie, g.sous_cat, g.ref].concat((g.coloris || []).map(function (c) { return c.couleur; })).join(' ')) };
    });
    return IDX_RECH;
  }
  function rendreRecherche(q) {
    var res = $('#rechRes');
    if (!res) return;
    // Catalogue absent ou vide (on-catalogue.js non chargé, fichier vide ou cassé) : jamais « Aucun modèle » — message distinct.
    if (!Array.isArray(window.CATALOGUE) || !window.CATALOGUE.length) {
      res.innerHTML = '<p class="rech__vide">Le catalogue est momentanément indisponible. Rechargez la page.</p>' +
        '<button type="button" class="btn btn--outline" data-on-recharger>Recharger</button>';
      res.querySelector('[data-on-recharger]').addEventListener('click', function () { location.reload(); });
      return;
    }
    var mots = ON.normaliser(q).split(/\s+/).filter(Boolean);
    if (!mots.length) { res.innerHTML = '<p class="rech__vide">Tapez le nom d’un modèle, une activité ou un genre.</p>'; return; }
    var trouves = indexRecherche().filter(function (x) { return mots.every(function (m) { return x.foin.indexOf(m) !== -1; }); });
    if (!trouves.length) { res.innerHTML = '<p class="rech__vide">Aucun modèle ne correspond à « ' + esc(q) + ' ».</p>'; return; }
    var haut = trouves.slice(0, 24);
    res.innerHTML = '<p class="rech__n" aria-live="polite">' + trouves.length + (trouves.length > 1 ? ' modèles' : ' modèle') + '</p>' +
      '<div class="rech__grille">' + haut.map(function (x) {
        var g = x.g, c = (g.coloris || [])[0] || {}, p = ON.prixDe(c.prix ? c : g), u = (c.images && c.images[0]) || g.image || '';
        return '<a class="rech__item" href="' + esc(c.url || g.url) + '">' +
          (u ? '<img src="' + esc(ON.img(u, 360)) + '" srcset="' + esc(ON.srcset(u, [180, 270, 360, 540, 720])) +
            '" sizes="(max-width: 699px) 45vw, 200px" alt="" loading="lazy" decoding="async" width="120" height="120">' : '') +
          '<span class="rech__nom">' + esc(g.nom) + '</span>' +
          '<span class="rech__desc">' + esc([g.rayon, g.sous_cat].filter(Boolean).join(' – ')) + '</span>' +
          '<span class="rech__prix">' + (p.barre ? '<s>' + ON.prix(p.barre) + '</s> ' : '') + ON.prix(p.paye) + '</span></a>';
      }).join('') + '</div>' +
      (trouves.length > haut.length ? '<p class="rech__vide">… et ' + (trouves.length - haut.length) + ' autres. <a href="/search?q=' +
        encodeURIComponent(q) + '">Affinez votre recherche</a> ou voyez tous les résultats.</p>' : '');
  }
  function ouvrirRecherche(decl) {
    var p = $('#rech'), champ = $('#rechInput');
    if (!p || !champ) { location.href = '/search'; return; }
    rendreRecherche(champ.value);
    ON.panneau.ouvrir('rech', decl, { focus: champ, voile: false });
  }

  /* ---------- 10. En-tête : seuil de l'accueil par IntersectionObserver (défauts 1, 2, 57), méga-menu clavier et tactile (10) ---------- */
  function initEntete() {
    var hdr = $('#hdr');
    if (!hdr) return;
    var hero = $('.hero') || $('[data-hero]');
    if (hdr.classList.contains('hdr--over')) {
      var heroVisible = !!hero, bureau = window.matchMedia('(min-width: 1000px)');
      var maj = function () {
        // Bureau : blanc dès qu'on défile (l'en-tête transparent ne passe plus sur les boutons du héros).
        // Mobile : la barre d'onglets prend le relais une fois le héros passé (comportement de la référence, seuil recalculé).
        var solide = bureau.matches ? window.scrollY > 4 : !heroVisible;
        hdr.classList.toggle('is-solid', solide);
      };
      if (hero && 'IntersectionObserver' in window) {
        // Seuil de la référence (hero.offsetHeight − 90), recalculé à chaque rotation ou redimensionnement : le héros est « passé »
        // quand son bas remonte sous la barre d'en-tête + 70 px.
        var marge = function () { return -(parseInt(getComputedStyle(document.documentElement).getPropertyValue('--nav-h'), 10) || 60) - 70; };
        var io, poser = function () {
          if (io) io.disconnect();
          io = new IntersectionObserver(function (l) { heroVisible = l[l.length - 1].isIntersecting; maj(); }, { rootMargin: marge() + 'px 0px 0px 0px', threshold: 0 });
          io.observe(hero);
        };
        poser();
        if (bureau.addEventListener) bureau.addEventListener('change', function () { poser(); maj(); });
        window.addEventListener('orientationchange', function () { setTimeout(poser, 200); });
      } else heroVisible = false;
      window.addEventListener('scroll', maj, { passive: true });
      maj();
    }
    // Méga-menu : ouvert au survol, au focus et au toucher ; Échap le referme ; aria-expanded tenu à jour.
    $$('.nav > li.has-sub', hdr).forEach(function (li) {
      var a = $(':scope > a', li);
      if (!a) return;
      a.setAttribute('aria-haspopup', 'true');
      a.setAttribute('aria-expanded', 'false');
      var etat = function () {
        var ouvert = !li.classList.contains('is-ferme') && (li.matches(':hover') || li.contains(document.activeElement) || li.classList.contains('is-ouvert'));
        a.setAttribute('aria-expanded', String(ouvert));
      };
      li.addEventListener('mouseenter', function () { li.classList.remove('is-ferme'); etat(); });
      li.addEventListener('mouseleave', function () { li.classList.remove('is-ferme', 'is-ouvert'); setTimeout(etat, 0); });
      li.addEventListener('focusin', function () { if (!li.classList.contains('is-ferme')) etat(); });
      li.addEventListener('focusout', function () { setTimeout(function () { if (!li.contains(document.activeElement)) li.classList.remove('is-ferme', 'is-ouvert'); etat(); }, 0); });
      a.addEventListener('click', function (e) {
        // Écran tactile au-delà de 1000 px : 1er toucher = ouvre le panneau, 2e = suit le lien.
        if (window.matchMedia('(hover: none)').matches && !li.classList.contains('is-ouvert')) {
          e.preventDefault();
          $$('.nav > li.is-ouvert', hdr).forEach(function (x) { x.classList.remove('is-ouvert'); });
          li.classList.add('is-ouvert'); li.classList.remove('is-ferme'); etat();
        }
      });
      li.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.stopPropagation(); li.classList.add('is-ferme'); li.classList.remove('is-ouvert'); a.focus(); etat(); }
        else if ((e.key === 'ArrowDown') && e.target === a) { e.preventDefault(); li.classList.remove('is-ferme'); var p = $('.sub a', li); if (p) p.focus(); }
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest || e.target.closest('.nav > li.has-sub')) return;
      $$('.nav > li.is-ouvert', hdr).forEach(function (x) { x.classList.remove('is-ouvert'); var a = $(':scope > a', x); if (a) a.setAttribute('aria-expanded', 'false'); });
    });
  }

  /* ---------- 11. Bandeau : rotation seulement à partir de 2 messages, pause au survol et au focus, rien en mouvement réduit (16) ---------- */
  function initAnnonce() {
    var b = $('#annonce'), msgs = $$('.annonce__msg', b);
    if (msgs.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0, pause = false;
    b.addEventListener('mouseenter', function () { pause = true; });
    b.addEventListener('mouseleave', function () { pause = false; });
    b.addEventListener('focusin', function () { pause = true; });
    b.addEventListener('focusout', function () { pause = false; });
    setInterval(function () {
      if (pause || document.hidden) return;
      msgs[i].classList.remove('is-on'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-on');
    }, 3000);
  }

  /* ---------- 12. Page « Mes favoris » (/pages/favoris) ---------- */
  function initFavorisPage(g) {
    var grille = g || $('#favGrid');
    if (!grille || grille.dataset.onFav) return;
    grille.dataset.onFav = '1';
    var rendre = function () {
      var html = ON.favoris.liste().map(function (id) {
        var g = ON.groupe(id); return g ? ON.carte(g, { coloris: id, sizes: '(max-width: 759px) 50vw, (min-width: 1600px) 520px, 33vw' }) : '';
      }).join('');
      grille.innerHTML = html || '<div class="empty"><p>Aucun favori pour le moment.</p><a class="btn" href="/collections/all">Découvrir la collection</a></div>';
      grille.classList.toggle('grid--vide', !html);
      ON.cartes(grille);
    };
    rendre();
    document.addEventListener('on:favoris', rendre);
  }

  ON.favorisPage = initFavorisPage;   // rendu de la grille « Mes favoris » (appelé au démarrage si #favGrid existe)

  /* ---------- 13. Démarrage ---------- */
  function demarrer() {
    indexer();
    initEntete();
    initAnnonce();
    var champ = $('#rechInput');
    if (champ) champ.addEventListener('input', function () { rendreRecherche(champ.value); });
    initFavorisPage();
    ON.rails(document);
    if (PANIER) peindre(PANIER);
    ON.panier.importer().then(function () { return ON.panier.rafraichir(); }).catch(function () {});
    // Cartes et rails ajoutés plus tard (filtres, « Voir plus ») : initialisés d'eux-mêmes, une fois.
    if (window.MutationObserver) {
      var prevu = false;
      new MutationObserver(function (l) {
        if (prevu) return;
        for (var i = 0; i < l.length; i++) if (l[i].addedNodes.length) { prevu = true; break; }
        if (prevu) requestAnimationFrame(function () { prevu = false; ON.rails(document); });
      }).observe(document.body, { childList: true, subtree: true });
    }
    // Le panier change dans un autre onglet : la pastille suit au retour.
    document.addEventListener('visibilitychange', function () { if (!document.hidden) ON.panier.rafraichir().catch(function () {}); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
})();
